<template>
 
  <div ref="act" >
    <template>
      <artmisads-modal
        v-model:open="configs.open"
        @ok="onOk"
        @cancel="onModalCancel"
        :getContainer="() => $refs.act"
        style="width: 600px"
        :title="
          configs.activeTab == '0'
            ? $t('seller.brandsPage.modalActivateAttribution')
            : $t('seller.brandsPage.modalActivateAssociate')
        "
        :ok-text="$t('seller.common.confirm')"
      >
        <div class="active-brand">
          <div class="top">
            <div class="top-left">
              <div
                class="brand-img-show"
                :style="
                  item?.logoImageUrl
                    ? { background: 'rgba(238, 237, 242, 1)' }
                    : ''
                "
              >
                <img :src="item.logoImageUrl" v-if="item.logoImageUrl" />
                <span class="brand-name" v-else>{{
                  item.amazonBrandName
                }}</span>
              </div>
            </div>
            <div class="top-right">
              <div class="top-right-title">
                {{ item.amazonBrandName }}
              </div>
              <div class="top-right-content">
                <div class="top-right-status">
                  <div class="top-right-status-title">{{ $t('seller.common.status') }}</div>
                  <Status
                    :type="item.status.toLowerCase()"
                    v-if="configs.activeTab == '0'"
                    :noBorder="true"
                    :text="
                      item.status == 'active'
                        ? $t('seller.common.active')
                        : $t('seller.common.inactive')
                    "
                    style="margin-top: 4px"
                  />
                  <Status
                    :type="item.associateStatus.toLowerCase()"
                    v-if="configs.activeTab == '1'"
                    :noBorder="true"
                    :text="
                      item.associateStatus == 'active'
                        ? $t('seller.common.active')
                        : $t('seller.common.inactive')
                    "
                    style="margin-top: 4px"
                  />
                </div>
                <div class="top-right-mid"></div>
                <div class="top-right-products">
                  <div class="top-right-status-title">
                    {{ $t('seller.brandsPage.productsLabel') }}
                  </div>
                  <div class="top-right-status-count">
                    {{
                      configs.activeTab == '0'
                        ? item.activeProductCount
                        : item.associateActiveProductCount
                    }}
                    <a-popover placement="bottom">
                      <template #title>
                        <div class="pop-title">
                          {{ $t('seller.brandsPage.bulkActivatePopoverBefore') }}<span
                            style="
                              color: rgba(138, 100, 244, 1);
                              font-weight: 600;
                            "
                          >
                            {{
                              configs.activeTab == '0'
                                ? item.activeProductCount
                                : item.associateActiveProductCount
                            }}
                          </span
                          >{{ $t('seller.brandsPage.bulkActivatePopoverAfter') }}
                        </div>
                      </template>
                      <Icon name="wenhao-tianchong" class="wenhao" />
                    </a-popover>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="bottom-title">
              {{ $t('seller.brandsPage.importantNotice') }}
            </div>
            <div class="bottom-content">
              <Icon name="info-tianchong" class="tianchong" />
              <div>
                <p class="paragraph">
                  {{ $t('seller.brandsPage.activateNoticeBrandP1Before')
                  }}<span class="bold">{{ $t('seller.brandsPage.activateNoticeBrandP1Bold') }}</span>{{ $t('seller.brandsPage.activateNoticeBrandP1After') }}
                </p>
                <p class="paragraph" style="margin: 16px 0">
                  {{ $t('seller.brandsPage.activateNoticeBrandP2Before')
                  }}<span class="bold">{{ $t('seller.brandsPage.activateNoticeBrandP2Bold') }}</span>{{ $t('seller.brandsPage.activateNoticeBrandP2After') }}
                </p>
                <p class="paragraph">
                  {{ $t('seller.brandsPage.activateNoticeBrandP3Before')
                  }}<span class="bold">{{ $t('seller.brandsPage.activateNoticeBrandP3Bold') }}</span>{{ $t('seller.brandsPage.activateNoticeBrandP3After') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </artmisads-modal>
    </template>
  </div>
 
</template>
<script setup name="tableModal">
import { ref, reactive, toRefs, computed, watch, watchEffect } from 'vue'
import { message } from 'ant-design-vue'

import Status from '@/components/Status.vue'
import Icon from '@/components/Icon.vue'



const { configs, item } = defineProps({
  configs: {
    type: Object,
    default: () => {},
  },
  item: {
    type: Object,
    default: () => {},
  },
})
const emit = defineEmits(['cancel', 'ok'])

const brandProfile = reactive({})

watch([() => configs.modalType], (newVal) => {
  if (newVal == 'updateProfile') {
    Object.assign(brandProfile, item)
  }
})
const onModalCancel = (e) => {
  emit('cancel')
}


const onOk = (e) => {
  let res = { ...item }
  // if (configs.modalType == "setCommission") {
  //   res.commissionRate = setCommission.commission;
  //   if (!res.commissionRate) {
  //     message.error("please input commission!", 1);
  //     return;
  //   }
  // }
  
  emit('ok', res)
}
</script>
<style lang="less" scoped>
@space: 16px;

@second-font: {
  opacity: 0.5;
  font-family: Sora, sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: var(--dark-1);
  letter-spacing: 0.4px;
  line-height: 22px;
};

.top {
  display: flex;
  align-items: center;
  gap: 16px;

  .top-left {
  }

  .wenhao {
    fill: var(--dark-4);
  }

  .top-right {
    .top-right-title {
      font-family: Sora;
      font-weight: 500;
      font-style: Medium;
      font-size: 15px;
      margin-bottom: 16px;
    }

    .top-right-content {
      display: flex;
      align-items: center;

      .top-right-status-title {
        font-family: Sora;
        font-weight: 500;
        font-style: Medium;
        font-size: 14px;
        color: rgba(135, 130, 148, 1);
      }

      .top-right-status-count {
        font-family: Sora;
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        margin-left: 4px;
      }

      .top-right-status {
        display: flex;
        align-items: center;
      }

      .top-right-mid {
        width: 2px;
        height: 10px;
        opacity: 1;
        background-color: rgba(232, 229, 237, 1);
        margin: 0 18px;
      }
    }

    .top-right-products {
      display: flex;
      align-items: center;
    }
  }
}

.bottom {
  margin-top: 42px;

  .bottom-title {
    margin-bottom: 14px;
    font-family: Sora;
    font-weight: 500;
    font-size: 13px;
  }

  .bottom-content {
    border-radius: 8px;
    background-color: rgba(80, 64, 128, 0.08);
    padding: 10px;
    display: flex;
    gap: 10px;
  }

  .tianchong {
    color: rgba(131, 92, 242, 1);
    width: 26px;
    height: 26px;
  }

  .paragraph {
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
  }

  .paragraphContent {
    font-family: Sora;
    font-weight: 700;
    font-style: Bold;
    font-size: 13px;
  }

  .bold {
    font-family: Sora;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 13px;
    color: rgba(131, 92, 242, 1);
    padding: 0 3px;
  }
}

.title-ext {
  @second-font();
  margin-bottom: @space;
}

.modal-title {
  border-radius: 8px 8px 0 0;
  font-family: Sora, sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: var(--dark-1);
  letter-spacing: 0.5px;
  line-height: 27px;
  margin-right: 16px;
}

.footer {
  display: flex;
  justify-content: flex-start;
}

.deactive-brand {
  .deactive {
    font-weight: 400;
    font-size: 14px;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    line-height: 22px;
    // padding: 24px 17px 24px 24px;
  }
}

.active-brand {
  // padding: 24px 17px 24px 24px;
  .brand-name-row {
    margin-bottom: 8px;
    display: flex;
    flex-wrap: wrap;
  }

  .brand-name {
    font-family: Sora, sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    line-height: 21px;
  }

  .content {
    font-family: Sora, sans-serif;
    font-weight: 400;
    font-size: 14px;
    color: var(--dark-1);
    letter-spacing: 0.4px;
    line-height: 22px;
  }

  // .login-country{
  //   color: #999;
  // }
}

.update-brand-profile {
  :deep(label) {
    @second-font();
    opacity: 0.7;
    font-weight: 500;
    line-height: 20px;
  }

  .upload_part {
    display: flex;
    align-items: flex-end;
  }

  .upload {
    width: 120px;
    height: 120px;
    background: var(--big-bg-1);
    border-radius: 8px;
    margin-right: 8px;

    .upload-icon {
      border: 2px dashed var(--border-1);
      border-radius: 8px;
      @second-font();
      width: inherit;
      height: inherit;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 36px;

      &:hover {
        background-color: var(--bg-gray-2);
        border-color: var(--bg-gray-7);
      }
    }

    .upload-img {
      width: 100%;
      height: 100%;
      border-radius: 8px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }

      &:hover {
        cursor: pointer;
      }
    }
  }

  .suggested {
    @second-font();
    letter-spacing: 0.3px;
    line-height: 18px;
    margin-top: 4px;
  }
}

.tip {
  padding: 8px;
  display: flex;
  margin-top: 16px;
  border-radius: 8px;
  color: var(--dark-2);
  background: var(--yellow-3);
  border: 1px solid var(--yellow-8);

  > .iconfont {
    flex: 1;
    height: 16px;
    font-size: 16px;
    min-width: 16px;
    margin-top: 2px;
    margin-right: 8px;
    color: var(--yellow-7);

    &:before {
      display: block;
      margin-top: -4px;
    }
  }
}

.brand-img-show {
  width: 56px;
  height: 56px;
  display: flex;
  border-radius: 8px;
  align-items: center;
  background: var(--bg-gray-2);

  img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .brand-name {
    margin: 0 auto;
    padding: 0 4px;
    max-width: 56px;
    font-size: 11px;
    overflow: hidden;
    max-height: 39px;
    font-weight: 600;
    line-height: 13px;
    text-align: center;
    color: var(--dark-4);
    letter-spacing: 0.3px;
  }
}
</style>
